module.exports = __webpack_public_path__ + "static/CK_FCC1-11399a13ffd33f8dc8e1cbf18d299550.jpg";